import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import loadable from '@loadable/component';

import { papCategories } from '../constants/postad';
import PrivateRoute from './PrivateRoute';

const PostAdPage = loadable(() => import('../containers/pap/PostAd'));
const EditAdPage = loadable(() => import('../containers/pap/EditAd'));
const PostAdRE = loadable(() => import('../containers/realestate/PostAd'));
const EditAdRE = loadable(() => import('../containers/realestate/EditAd'));
const SuccessRE = loadable(() => import('../containers/success'));
const ConfirmPage = loadable(() => import('../containers/confirm/ConfirmPage'));
const ConfirmPageRE = loadable(() => import('../containers/confirm/ConfirmPageRE'));
const PostAdSelection = loadable(() => import('../containers/postAdSelection'));
const UpgradeAd = loadable(() => import('../containers/upgradeAd'));

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" render={() => <h1>Homepage</h1>} />
      <Route exact path="/post-ad" component={PostAdSelection} />
      <Route exact path="/upgrade-ad" component={UpgradeAd} />
      <PrivateRoute
        exact
        path="/post-ad/:category(realestate)/confirm"
        component={ConfirmPageRE}
        redirectTo="pap"
      />
      <PrivateRoute
        exact
        path={`/post-ad/:category(${papCategories})/:subcat([a-zA-Z0-9-]+)/confirm`}
        component={ConfirmPage}
        redirectTo="pap"
      />
      <Route
        exact
        path={`/post-ad/:category(${papCategories})/:subcat([a-zA-Z0-9-]+)`}
        component={PostAdPage}
      />
      <PrivateRoute exact path="/edit-ad/:adId" component={EditAdPage} />
      <PrivateRoute exact path="/postad/confirm" component={ConfirmPageRE} redirectTo="pap" />
      <Route exact path="/postad" component={PostAdRE} />
      <Route exact path="/post-ad/:category(realestate)" component={PostAdRE} />
      <PrivateRoute exact path="/editad/:id" component={EditAdRE} />
      <Route exact path="/success" component={SuccessRE} />
      <Route exact path="/post-ad/success" component={SuccessRE} />
      <Route exact path="/404Error" render={() => <h1>Local Error Page</h1>} />
      <Route render={() => <Redirect to="/404Error" />} />
    </Switch>
  );
};

export default Routes;
